import { Link } from 'react-router-dom'
import fileSize from 'filesize'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import type { GetPaymentInfoResponse } from '@jotta/grpc-connect-openapi/payment'

import { BizWidget } from '../widgets/BizWidget'

export function BizSubscriptionForm({
  paymentInfo,
  maxUserCount,
  userCount,
}: {
  paymentInfo: GetPaymentInfoResponse
  maxUserCount: number
  userCount: number
}) {
  return (
    <BizWidget title={t`Subscription`}>
      <dl className="dl">
        <dt>
          <Trans>Account Type</Trans>
        </dt>
        <dd>{paymentInfo.subscriptionNameLocalized}</dd>
        <dt>
          <Trans>Total storage</Trans>
        </dt>
        <dd>
          {fileSize(Number(paymentInfo.subscriptionQuotaBytes))} (
          {fileSize(Number(paymentInfo.subscriptionUsageBytes))}{' '}
          <Trans>used</Trans>)
        </dd>
        <dt>
          <Trans>Users</Trans>
        </dt>
        <dd>
          {maxUserCount < 0 ? (
            <Trans>Unlimited user seats ({userCount} in use)</Trans>
          ) : (
            <Trans>
              {userCount} of {maxUserCount} user seats occupied
            </Trans>
          )}
        </dd>
      </dl>
      <Link to="/web/upgrade" className="btn btn-outline mt-6">
        <Trans>Change subscription</Trans>
      </Link>
    </BizWidget>
  )
}
